export default "__VITE_ASSET__DETIsd09__"